export default "__VITE_ASSET__D2ebuXDT__"